import {
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type CommentModel from './comment';
import type InitiativeModel from './initiative';
import type PersonModel from './person';
import TeamBasedModel from './team-based-model';
import type TeamModel from './team';

export default class LlModel extends TeamBasedModel {
  declare [Type]: 'll';
  @belongsTo('team', { inverse: 'lls', async: true })
  declare team: AsyncBelongsTo<TeamModel>;
  @belongsTo('person', { inverse: 'lls', async: true })
  declare author: AsyncBelongsTo<PersonModel>;
  @hasMany('comment', { async: true, inverse: 'll' })
  declare comments: AsyncHasMany<CommentModel>;
  @hasMany('person', { async: true, inverse: null })
  declare assignees: AsyncHasMany<PersonModel>;
  @belongsTo('initiative', { inverse: 'lls', async: true })
  declare initiative: AsyncBelongsTo<InitiativeModel>;
}
